import { render } from "./single-vehicle.vue?vue&type=template&id=e9b64eaa"
import script from "./single-vehicle.vue?vue&type=script&lang=js"
export * from "./single-vehicle.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__